import { Field, InputType, Int, ObjectType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import GraphQLJSON from 'graphql-type-json'
import type { FilterQuery } from '../../repository/types'
import type { Task } from '../Task'

@InputType()
export class GetTaskStatusCountsArgs extends ActionArgs {
  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<Task>
}

@ObjectType()
export class TaskStatusCountsResult {
  @Field(() => Int)
  all: number

  @Field(() => Int)
  draft: number

  @Field(() => Int)
  inProgress: number

  @Field(() => Int)
  complete: number

  @Field(() => Int)
  cancelled: number
}

export interface IGetTaskStatusCounts extends IAction<TaskStatusCountsResult, GetTaskStatusCountsArgs> {}
